'use strict';

import Urls from '../definitions/Urls';
import {getTime} from "../utils/TimeUtils";

const iFrameNavigationListener = (setLastActive) => (message) => {
  // get
  if (message.origin !== Urls.medixineApi()) return;

  if (message.data && message.data.eventType === 'AjaxLoad') {
    window.scroll(0, 0);
    setLastActive(getTime())
  }
}

export default iFrameNavigationListener
